var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// API_BASE is empty in production (frontend is served by the same Go
// process as the API) and points at the backend's dev port during
// `npm start`, where webpack-dev-server and the Go API run on different
// ports.
var API_BASE = process.env.RIGORMINING_API_BASE || '';
function request(path, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var isFormData, res, text;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isFormData = options.body instanceof FormData;
                    return [4 /*yield*/, fetch("" + API_BASE + path, __assign(__assign({}, options), { credentials: 'include', headers: __assign(__assign({}, (!isFormData && options.body ? { 'Content-Type': 'application/json' } : {})), options.headers) }))];
                case 1:
                    res = _a.sent();
                    if (!!res.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, res.text().catch(function () { return ''; })];
                case 2:
                    text = _a.sent();
                    throw new Error(res.status + " " + res.statusText + (text ? ": " + text : ''));
                case 3:
                    if (res.status === 204) {
                        return [2 /*return*/, undefined];
                    }
                    return [2 /*return*/, res.json()];
            }
        });
    });
}
// The user's tag list, fetched once and shared by every component that
// wants it (tag autocomplete). Dropped whenever tags change, so the next
// listTags() refetches.
var tagsCache = null;
var invalidateTags = function (result) {
    tagsCache = null;
    return result;
};
export var api = {
    whoami: function () { return request('/api/v1/whoami'); },
    listItems: function (params) {
        if (params === void 0) { params = {}; }
        var qs = new URLSearchParams();
        if (params.q)
            qs.set('q', params.q);
        if (params.sync_state)
            qs.set('sync_state', params.sync_state);
        var suffix = qs.toString() ? "?" + qs.toString() : '';
        return request("/api/v1/items" + suffix);
    },
    getItem: function (id) { return request("/api/v1/items/" + id); },
    uploadItemFile: function (id, file) {
        var form = new FormData();
        form.set('file', file);
        return request("/api/v1/items/" + id + "/file", { method: 'POST', body: form });
    },
    createItem: function (metadata, file) {
        var form = new FormData();
        form.set('metadata', JSON.stringify(metadata));
        if (file)
            form.set('file', file);
        return request('/api/v1/items', { method: 'POST', body: form });
    },
    updateItem: function (id, metadata) {
        return request("/api/v1/items/" + id, { method: 'PATCH', body: JSON.stringify(metadata) });
    },
    deleteItem: function (id) { return request("/api/v1/items/" + id, { method: 'DELETE' }); },
    // Looks up the item's citation (Crossref/arXiv/Open Library) without
    // saving anything.
    lookupCitation: function (id) { return request("/api/v1/items/" + id + "/citation"); },
    addTag: function (id, name) {
        return request("/api/v1/items/" + id + "/tags", { method: 'POST', body: JSON.stringify({ name: name }) }).then(invalidateTags);
    },
    removeTag: function (id, tagId) {
        return request("/api/v1/items/" + id + "/tags/" + tagId, { method: 'DELETE' }).then(invalidateTags);
    },
    // Cached - see tagsCache.
    listTags: function () {
        if (!tagsCache) {
            tagsCache = request('/api/v1/tags').catch(function (err) {
                tagsCache = null;
                throw err;
            });
        }
        return tagsCache;
    },
    // Renames a tag on all the user's items (merging into an existing tag
    // of that name) and returns the updated tag list.
    renameTag: function (from, to) { return __awaiter(void 0, void 0, void 0, function () {
        var tags;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request('/api/v1/tags/rename', {
                        method: 'POST',
                        body: JSON.stringify({ from: from, to: to }),
                    })];
                case 1:
                    tags = _a.sent();
                    tagsCache = Promise.resolve(tags);
                    return [2 /*return*/, tags];
            }
        });
    }); },
    requestSync: function (id) { return request("/api/v1/items/" + id + "/sync", { method: 'POST' }); },
    cancelSync: function (id) { return request("/api/v1/items/" + id + "/sync", { method: 'DELETE' }); },
    ackSync: function (id, result) {
        return request("/api/v1/items/" + id + "/sync/ack", { method: 'POST', body: JSON.stringify({ result: result }) });
    },
    listTokens: function () { return request('/api/v1/tokens'); },
    createToken: function (name) {
        return request('/api/v1/tokens', { method: 'POST', body: JSON.stringify({ name: name }) });
    },
    deleteToken: function (id) { return request("/api/v1/tokens/" + id, { method: 'DELETE' }); },
    fileUrl: function (id) { return API_BASE + "/api/v1/items/" + id + "/file"; },
    exportUrl: function (id) { return API_BASE + "/api/v1/items/" + id + "/export.md"; },
    bibtexUrl: function (id) { return API_BASE + "/api/v1/items/" + id + "/export.bib"; },
    tagBibtexUrl: function (tag) { return API_BASE + "/api/v1/items/export.bib?tag=" + encodeURIComponent(tag); },
    extensionUrl: function (browser) { return API_BASE + "/api/v1/extension/" + browser; },
    skillUrl: function (name) { return API_BASE + "/api/v1/skills/" + name; },
    fetchFileBlob: function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE + "/api/v1/items/" + id + "/file", { credentials: 'include' })];
                case 1:
                    res = _a.sent();
                    if (!res.ok)
                        throw new Error("could not fetch file: " + res.status);
                    return [2 /*return*/, res.blob()];
            }
        });
    }); },
};
export var loginUrl = API_BASE + "/login";
export var logoutUrl = API_BASE + "/-/logout";
export var devLoginUrl = API_BASE + "/dev-login";
